module.exports = require('client-v2/common/models/interest/actions')
